export const organizationEndpoints = {
  getCoturnCredentials: (id: string) => `/private/v1/organization/${id}/coturnCredentials`,
} as const;

export type OrganizationEndpointKey = keyof typeof organizationEndpoints;
